<template>
  <page-edicion>
    <page-header title="Crear forma de pago" back-to="/formasPago" />
    <formulario-forma-pago :forma-pago="formaPago" @submit="insertar" />
  </page-edicion>
</template>

<script>
import FormularioFormaPago from "./FormularioFormaPago.vue";
import api from "@/services/formasPago.js";

export default {
  components: { FormularioFormaPago },
  data() {
    return {
      formaPago: api.crear(),
    };
  },
  methods: {
    insertar() {
      api.insertar(this.formaPago).then(() => {
        this.$messages.success("Se ha creado la forma de pago");
        this.$router.push({ path: "/formasPago" });
      });
    },
  },
};
</script>
